import React, { useEffect, useState, useContext } from 'react';
import { useField, useFormikContext } from 'formik';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { PlaceStoreContext } from '../reducers/Place/PlaceContext';
import Button from '@mui/material/Button';

export const EditToppingGroup = ({ label, selected, disabled, ...props }) => {
  const [placeState] = useContext(PlaceStoreContext);
  const {
    toppings: { toppingGroupId__toppingsGroups },
  } = placeState;

  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();
  const [availableToppingGroups, setAvailableToppingGroups] = useState(null);

  // const initialToppingGroup = product
  //   ? product.topping_group_id || ''
  //   : toppingGroupId || ''

  // const [toppingGroup, setToppingGroup] = useState(initialToppingGroup);

  useEffect(() => {
    const toppingGroups = [];
    for (const toppingGroupId in toppingGroupId__toppingsGroups) {
      toppingGroupId__toppingsGroups[toppingGroupId] && toppingGroups.push(toppingGroupId__toppingsGroups[toppingGroupId]);
    }
    setAvailableToppingGroups(toppingGroups.sort((a, b) => a.name.localeCompare(b.name)));
  }, [placeState]);

  const handleClearToppingGroup = () => {
    setFieldValue(field.name, '');
  }

  if (!availableToppingGroups) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
    <TextField
      fullWidth
      select
      disabled={availableToppingGroups.length === 0 || disabled}
      variant="outlined"
      label={availableToppingGroups.length === 0 ? `No Topping Groups found` : label}
      defaultValue={selected}
      helperText={meta.touched && meta.error}
      error={meta.touched && !!meta.error}
      {...field}
      {...props}
    >
        {availableToppingGroups.map((toppingGroup) => {
          return (
            <MenuItem key={toppingGroup.id} value={toppingGroup.id}>
              {toppingGroup.name}
            </MenuItem>
          )
        })}
    </TextField>
    <Button variant="contained" color="secondary" onClick={handleClearToppingGroup} style={{ marginLeft: '16px', maxHeight: '30px' }}>
      CLEAR
    </Button>
    </div>
  );
};
